import React, { Component } from 'react';
import { Col, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import '../../css/phone/phone.css';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SignalRService from "../../controllers/SignalRService";
import { changeJanusStatus } from '../../redux/parametersSlice';
import Display from './display';

class Talking extends Component {

    constructor() {
        super();

        this.state = {
            mute: false,
            pause: false,
        };
        this.hold = this.hold.bind(this);
        this.retrieve = this.retrieve.bind(this);
        this.transference = this.transference.bind(this);
        this.swap = this.swap.bind(this);
        this.conference = this.conference.bind(this);
        this.startRecording = this.startRecording.bind(this);
        this.stopRecording = this.stopRecording.bind(this);
        this.mute = this.mute.bind(this);
        this.unmute = this.unmute.bind(this);
        this.pauseRecording = this.pauseRecording.bind(this);
        this.resumeRecording = this.resumeRecording.bind(this);
    }

    componentDidMount() {

        document.addEventListener("janusMessage", this.setPause);
    }

    setPause = (e) => {

        if (e.detail) {
            this.setState({
                pause: e.detail.recmuting
            });
        }

    }
    toggleTransfer = e => {
        this.setState({ showTransfer: !this.state.showTransfer, showOptions: false, showPhone: true });
    }

    hold = (e) => {
        e.preventDefault();
        SignalRService.hold({
            "extension": this.props.extension,
            "userId": this.props.userId
        });
    }

    retrieve = (e) => {
        e.preventDefault();
        SignalRService.retrieve({
            "extension": this.props.extension,
            "userId": this.props.userId
        });
    }

    transference = (e) => {
        e.preventDefault();
        SignalRService.transference({
            "extension": this.props.extension,
            "userId": this.props.userId
        });
    }

    swap = (e) => {
        e.preventDefault();
        SignalRService.swap({
            "extension": this.props.extension,
            "userId": this.props.userId
        });
    }

    conference = (e) => {
        e.preventDefault();
        SignalRService.conference({
            "extension": this.props.extension,
            "userId": this.props.userId
        });
    }

    startRecording = (e) => {
        e.preventDefault();
        SignalRService.startRecording({
            "extension": this.props.extension,
            "userId": this.props.userId
        });
        if (this.props.functions.janus) {
            this.props.changeJanusStatus("startRecording");
        }
    }

    stopRecording = (e) => {
        e.preventDefault();
        SignalRService.stopRecording({
            "extension": this.props.extension,
            "userId": this.props.userId
        });
        if (this.props.functions.janus) {
            this.props.changeJanusStatus("stopRecording");
        }
    }

    mute() {
        this.setState({
            mute: true
        });
        this.props.changeJanusStatus("mute")
    }

    unmute() {
        this.setState({
            mute: false
        });
        this.props.changeJanusStatus("unmute")
    }

    pauseRecording() {
        SignalRService.muteRecording({
            "extension": this.props.extension,
            "userId": this.props.userId
        });
        this.props.changeJanusStatus("pauseRecording");
    }

    resumeRecording() {

        SignalRService.startRecording({
            "extension": this.props.extension,
            "userId": this.props.userId
        });

        this.props.changeJanusStatus("resumeRecording");
    }

    render() {
        return (
            <div className='talking'>
                <Display phoneStatus={this.props.phoneStatus} showPhone={true}></Display>
                <div className='talkingcontrols'>
                    <Row>
                        {
                            (this.props.janusStarted && this.props.functions.muteJanus) &&
                            <>
                                {
                                    (!this.state.mute) &&

                                    <Col>
                                        <button className='phonekey' onClick={this.mute}
                                            disabled={!this.props.phoneStatus.activeCallGUID && !this.props.phoneStatus.heldCallGUID}>
                                            <FontAwesomeIcon icon={duotone('microphone')} />
                                            <div className="fs-7">{this.props.t("mute")}</div>
                                        </button>
                                    </Col>
                                }
                                {
                                    (this.state.mute) &&
                                    <Col>
                                        <button className='phonekey' onClick={this.unmute}
                                            disabled={!this.props.phoneStatus.activeCallGUID && !this.props.phoneStatus.heldCallGUID}>
                                            <FontAwesomeIcon icon={duotone('microphone-slash')} />
                                            <div className="fs-7">{this.props.t("mute")}</div>
                                        </button>
                                    </Col>
                                }
                            </>
                        }
                        {
                            (this.props.functions.consultation && ((!this.props.phoneStatus.activeCallGUID || !this.props.phoneStatus.heldCallGUID) || (this.props.phoneStatus.activeCallGUID === this.props.phoneStatus.heldCallGUID))) &&
                            <Col>
                                <button className='phonekey' onClick={this.props.toggleQuery} disabled={"DIALING" === this.props.phoneStatus.ctiStatus}>
                                    <FontAwesomeIcon icon={duotone('square-question')} />
                                    <div className="fs-7">{this.props.t("query")}</div>
                                </button>
                            </Col>
                        }
                        {
                            (this.props.functions.transference && ((this.props.phoneStatus.activeCallGUID && this.props.phoneStatus.heldCallGUID)
                                && (this.props.phoneStatus.activeCallGUID !== this.props.phoneStatus.heldCallGUID))) &&
                            <Col>
                                <button className='phonekey' onClick={this.transference} disabled={"DIALING" === this.props.phoneStatus.ctiStatus}>
                                    <FontAwesomeIcon icon={duotone('arrow-right-arrow-left')} />
                                    <div className="fs-7" >{this.props.t("transfer")}</div>
                                </button>
                            </Col>
                        }
                        {
                            (this.props.functions.conference) &&
                            <Col>
                                <button className='phonekey' onClick={this.conference}
                                    disabled={!this.props.phoneStatus.activeCallGUID || !this.props.phoneStatus.heldCallGUID
                                        || this.props.phoneStatus.activeCallGUID === this.props.phoneStatus.heldCallGUID
                                        || "DIALING" === this.props.phoneStatus.ctiStatus}>
                                    <FontAwesomeIcon icon={duotone('merge')} />
                                    <div className="fs-7">{this.props.t("merge")}</div>
                                </button>
                            </Col>
                        }
                        {
                            (this.props.functions.holdRetrieve) &&
                            <>
                                {
                                    ("HELD" !== this.props.phoneStatus.ctiStatus && this.props.phoneStatus.heldCallGUID === null) &&
                                    <Col>
                                        <button className='phonekey' onClick={this.hold}
                                            disabled={(this.props.phoneStatus.activeCallGUID === null && this.props.phoneStatus.heldCallGUID !== null) || "DIALING" === this.props.phoneStatus.ctiStatus}>
                                            <FontAwesomeIcon icon={duotone('pause')} />
                                            <div className="fs-7">{this.props.t("hold")}</div>
                                        </button>
                                    </Col>
                                }
                                {
                                    ("HELD" === this.props.phoneStatus.ctiStatus || "BUSY" === this.props.phoneStatus.ctiStatus || (("TALKING" === this.props.phoneStatus.ctiStatus || "DIALING" === this.props.phoneStatus.ctiStatus) && this.props.phoneStatus.heldCallGUID != null)) &&
                                    <Col>
                                        <button className='phonekey' onClick={this.retrieve}
                                            disabled={this.props.phoneStatus.heldCallGUID === null || "RINGING" === this.props.phoneStatus.ctiStatus}>
                                            <FontAwesomeIcon icon={duotone('rotate-left')} />
                                            <div className="fs-7">{this.props.t("retrieve")}</div>
                                        </button>
                                    </Col>
                                }
                            </>
                        }
                        {
                            (this.props.functions.swap) &&
                            <Col>
                                <button className='phonekey' onClick={this.swap}
                                    disabled={!this.props.phoneStatus.heldCallGUID || (this.props.phoneStatus.activeCallGUID === this.props.phoneStatus.heldCallGUID)
                                        || "DIALING" === this.props.phoneStatus.ctiStatus}>
                                    <FontAwesomeIcon icon={duotone('arrows-retweet')} />
                                    <div className="fs-7">{this.props.t("swap")}</div>
                                </button>
                            </Col>
                        }
                        {
                            (this.props.functions.record) &&
                            <>
                                {
                                    ("STOP" === this.props.phoneStatus.recordingStatus) &&
                                    <Col>
                                        <button className='phonekey' onClick={this.startRecording}
                                            disabled={(!this.props.phoneStatus.activeCallGUID && !this.props.phoneStatus.heldCallGUID) || this.props.phoneStatus.alreadyRecorded}>
                                            <FontAwesomeIcon icon={duotone('circle')} />
                                            <div className="fs-7">{this.props.t("startrecording")}</div>
                                        </button>
                                    </Col>
                                }
                                {
                                    ("STOP" !== this.props.phoneStatus.recordingStatus) &&
                                    <>
                                        <Col>
                                            <button className='phonekey' onClick={this.stopRecording}
                                                disabled={!this.props.phoneStatus.activeCallGUID && !this.props.phoneStatus.heldCallGUID}>
                                                <FontAwesomeIcon icon={duotone('stop')} />
                                                <div className="fs-7">{this.props.t("stoprecording")}</div>
                                            </button>
                                        </Col>
                                        {
                                            (this.props.functions.muteRecord && (!this.props.phoneStatus.muteStatus && !this.state.pause)) &&
                                            <Col>
                                                <button className='phonekey' onClick={this.pauseRecording}
                                                    disabled={!this.props.phoneStatus.activeCallGUID && !this.props.phoneStatus.heldCallGUID}>
                                                    <FontAwesomeIcon icon={duotone('play-pause')} />
                                                    <div className="fs-7">{this.props.t("pause")}</div>
                                                </button>
                                            </Col>
                                        }
                                        {
                                            (this.props.functions.muteRecord && (this.props.phoneStatus.muteStatus === true || this.state.pause === true)) &&
                                            <Col>
                                                <button className='phonekey' onClick={this.resumeRecording}
                                                    disabled={!this.props.phoneStatus.activeCallGUID && !this.props.phoneStatus.heldCallGUID}>
                                                    <FontAwesomeIcon icon={duotone('play')} />
                                                    <div className="fs-7">{this.props.t("resume")}</div>
                                                </button>
                                            </Col>
                                        }
                                    </>
                                }
                            </>
                        }
                        {
                            //SIN PROBAR 
                            ((this.props.functions.record || this.props.functions.recordAnyway) && this.props.functions.muteRecord && !this.props.functions.janus) &&
                            <>
                                {
                                    (!this.props.phoneStatus.muteRecord) &&
                                    <Col>
                                        <button className='phonekey' onClick={this.startRecording}
                                            disabled={"STOP" === this.props.phoneStatus.recordingStatus}>
                                            <FontAwesomeIcon icon={duotone('circle')} />
                                            <div className="fs-7">Resume Recording</div>
                                        </button></Col>
                                }
                                {
                                    (this.props.phoneStatus.muteRecord) &&
                                    <Col>
                                        <button className='phonekey' onClick={this.stopRecording}
                                            disabled={"STOP" === this.props.phoneStatus.recordingStatus}>
                                            <FontAwesomeIcon icon={duotone('stop')} />

                                        </button>
                                    </Col>
                                }
                            </>
                        }
                        {
                            (this.props.functions.clasify && ["TALKING", "HELD", "DIALING", "RINGING"].indexOf(this.props.phoneStatus.ctiStatus) > -1) &&
                            <Col>
                                <button className='phonekey' onClick={this.props.toggleCategories}>
                                    <FontAwesomeIcon icon={duotone('tag')} />
                                    <div className="fs-7">{this.props.t("category")}</div>
                                </button>
                            </Col>
                        }
                        {
                            (this.props.functions.blindTransfer) &&
                            <Col>
                                <button className='phonekey' onClick={this.props.toggleTransfer}
                                    disabled={this.props.phoneStatus.heldCallGUID && this.props.phoneStatus.activeCallGUID && this.props.phoneStatus.heldCallGUID !== this.props.phoneStatus.activeCallGUID}>
                                    <FontAwesomeIcon icon={duotone('arrow-right')} />
                                    <div className="fs-7">{this.props.t("redirect")}</div>
                                </button>
                            </Col>
                        }
                    </Row>
                </div>
                <div className='talkingcontrols-bottom'>
                    <Row>
                        <Col>
                            <OverlayTrigger
                                placement="left"
                                delay={{ show: 250, hide: 400 }}
                                overlay={<Tooltip style={{ position: "fixed" }} >
                                    {this.props.t("back")}
                                </Tooltip>}>
                                <button className='phonekey' onClick={this.props.toggleKeys}><FontAwesomeIcon icon={duotone('keyboard-left')} /></button>
                            </OverlayTrigger>
                        </Col>
                        <Col>
                            {
                                (this.props.functions.hangup && ["HUNGUP"].indexOf(this.props.phoneStatus.ctiStatus) === -1) &&
                                <button className='hangup' onClick={this.props.hangup}> <FontAwesomeIcon size='3x' icon={solid('phone-hangup')} /></button>
                            }
                            {
                                (this.props.functions.answer && ["RINGING"].indexOf(this.props.phoneStatus.ctiStatus) > -1) &&
                                <button className='answer' onClick={this.props.answer} ><FontAwesomeIcon size='3x' icon={faPhone} /></button>
                            }
                        </Col>
                        <Col></Col>
                        {/* <Col>
                            {
                                (this.props.functions.blindTransfer) &&
                                <OverlayTrigger
                                    placement="left"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={<Tooltip style={{ position: "fixed" }} >
                                        {this.props.t("redirect")}
                                    </Tooltip>}>
                                    <button className='phonekey' onClick={this.props.toggleTransfer}><FontAwesomeIcon icon={duotone('arrow-right')} /></button>
                                </OverlayTrigger>
                            }
                        </Col> */}
                    </Row>
                </div>
            </div >
        )
    }
}

const mapStateToProps = (state) => {
    return {
        extension: state.agent.extension,
        userId: state.agent.userId,
        functions: state.agent.functions,
        janusStarted: state.parameters.janusStarted
    };
};

export default compose(connect(mapStateToProps, { changeJanusStatus }), withTranslation())(Talking);